import React from 'react';
import styled from 'styled-components';
import { Form, TextArea } from 'semantic-ui-react';

const TemplateDescription = ({ templateDescription, changeTemplateDescription }) => {
  return (
    <TemplateDescriptionBlock>
      <Label>Введите описание шаблона</Label>
      <Form className="template-description-input">
        <Form.Field
          control={TextArea}
          placeholder="Описание шаблона"
          value={templateDescription}
          onChange={(event) => changeTemplateDescription(event.target.value)}
          rows={3}
        />
      </Form>
    </TemplateDescriptionBlock>
  );
};

export default TemplateDescription;

const TemplateDescriptionBlock = styled.div`
  width: 100%;
`;

const Label = styled.label`
  width: 100%;
  font-size: 24px;
  cursor: pointer;
`;



// WEBPACK FOOTER //
// ./src/Components/TemplateGenerator/TemplateDescription.jsx